import { render, staticRenderFns } from "./PublicTemplate.vue?vue&type=template&id=2ef78fd6&scoped=true&"
import script from "./PublicTemplate.vue?vue&type=script&lang=js&"
export * from "./PublicTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef78fd6",
  null
  
)

export default component.exports